module.exports = __webpack_public_path__ + "follow.53ecc647.png";